import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

const highlight = (value, text) => {
    if (!value) {
        return text;
    }
    const parsedValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${parsedValue})`, 'i');
    if (text) {
        return text.replace(regex, "<span class='highlighter__highlighted'>$1</span>");
    }
    return '';
};
/**
Il componente Highlighter ha lo scopo di evidenziare una parola all'interno di un testo passato ed
è generalmente usato per evidenziare le occorrenze di una parola cercata in modo da aiutare l'utente a
identificarne le occorrenze in un testo lungo.
 */
function Highlighter({ className, value, text }) {
    const classes = cns('highlighter__text', className);
    return (jsx("span", { className: classes, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: highlight(value, text) } }));
}
Highlighter.defaultProps = {
    className: '',
    value: null,
    text: '',
};

export { Highlighter as default };
